import { z } from 'zod';
import { assertDeployedSecrets } from '@azzapp/shared/envGuard';

export const schema = z.object({
  NEXT_PUBLIC_WEB_APP_URL: z
    .url()
    .default('http://localhost:3003')
    .describe(
      'Public URL of the WebApp, used to build referral activation links',
    )
    .meta({ secret: { sensitivity: 'config' } }),
  CRON_SECRET: z
    .string()
    .default('')
    .describe('Secret for cron jobs')
    .meta({ secret: { sensitivity: 'secret', generated: true } }),
  NEXT_PUBLIC_SENTRY_DSN: z
    .string()
    .url()
    .optional()
    .describe('Sentry DSN for error tracking')
    .meta({ secret: { sensitivity: 'config', perProject: true } }),
  NEXT_PUBLIC_PLATFORM: z
    .enum(['production', 'staging', 'development'])
    .default('development')
    .describe('Platform environment')
    .meta({ secret: { sensitivity: 'config' } }),
  SECRET_COOKIE_PASSWORD: z
    .string()
    .default('')
    .describe('Secret for cookie encryption')
    .meta({
      secret: {
        sensitivity: 'secret',
        generated: true,
        rotation: { dualList: true },
      },
    }),
});

const env = schema.safeParse({
  ...process.env,
  NEXT_PUBLIC_WEB_APP_URL: process.env.NEXT_PUBLIC_WEB_APP_URL,
  NEXT_PUBLIC_SENTRY_DSN: process.env.NEXT_PUBLIC_SENTRY_DSN,
  NEXT_PUBLIC_PLATFORM: process.env.NEXT_PUBLIC_PLATFORM,
});

if (!env.success) {
  console.error(
    '❌ backoffice - invalid environment variables:',
    env.error.format(),
  );
}

assertDeployedSecrets(schema, env, 'backoffice');

export default env.data!;
